import { render, staticRenderFns } from "./AddressEditor.vue?vue&type=template&id=3edce428&"
import script from "./AddressEditor.vue?vue&type=script&lang=ts&"
export * from "./AddressEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports